import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import { AdminModule } from '@/store/modules/admin';
export const permission = {
  inserted(el, binding) {
    const {
      value
    } = binding;
    const adminsRoleIds = AdminModule.adminsRoleIds;
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value;
      const hasPermission = adminsRoleIds.some(adminsRoleId => {
        return permissionRoles.includes(adminsRoleId);
      });
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error("need roles! Like v-permission=\"['Super Admin','Admin']\"");
    }
  }
};